import { formatTime } from "projects/shared/src/lib/utils/time-formatter";
import { IMeetingRoomKioskData } from "../models/kiosk.model";

export const generateKioskTimeBlockersForDay = (
  kioskData: IMeetingRoomKioskData,
) => {
  const { events } = kioskData;
  return events.map((event) => ({
    startTime: formatTime(kioskData.meetingRoom.timezone, event.startTime),
    endTime: formatTime(kioskData.meetingRoom.timezone, event.endTime),
  }));
};
